(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cc-contact-form"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function hideLoader(formArea) {
      const loader = formArea.querySelector('.js-cc-contact-form-loader');

      if (!loader) {
        return;
      }

      loader.setAttribute('hidden', 'hidden');
    }

    function getEmbedIframe(formArea) {
      return (
        formArea.querySelector('iframe[id^="JotFormIFrame"]') ||
        formArea.querySelector('iframe[src*="jotform.com"]') ||
        formArea.querySelector('iframe')
      );
    }

    function bindIframeLoad(iframe, formArea) {
      if (!iframe || iframe.dataset.ccLoaderBound === 'true') {
        return;
      }

      iframe.dataset.ccLoaderBound = 'true';
      iframe.addEventListener(
        'load',
        function () {
          hideLoader(formArea);
        },
        { once: true }
      );
    }

    function setupLoader(formArea) {
      if (!formArea) {
        return;
      }

      const initialIframe = getEmbedIframe(formArea);
      if (initialIframe) {
        bindIframeLoad(initialIframe, formArea);
        return;
      }

      const observer = new MutationObserver(function () {
        const iframe = getEmbedIframe(formArea);
        if (iframe) {
          bindIframeLoad(iframe, formArea);
          observer.disconnect();
          return;
        }

        if (formArea.querySelector('.jfForm-wrapper, .jotform-form, .form-all')) {
          hideLoader(formArea);
          observer.disconnect();
        }
      });

      observer.observe(formArea, { childList: true, subtree: true });
    }

    function init() {
      const areas = document.querySelectorAll('.js-cc-contact-form-area');
      areas.forEach(setupLoader);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
      return;
    }

    init();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fall-campaign-download"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var SOURCE_SELECTOR = '.fall-download div.ctct-form-embed form.ctct-form-custom input.ctct-form-element';
    var TARGET_SELECTOR = 'input.ctct-form-element';

    function syncValue(value, sourceInput) {
      document.querySelectorAll(TARGET_SELECTOR).forEach(function (input) {
        if (input === sourceInput) return;
        input.value = value;
        input.dispatchEvent(new Event('input', { bubbles: true }));
      });
    }

    function handleInput(event) {
      var sourceInput = event.target.closest(SOURCE_SELECTOR);
      if (!sourceInput) return;
      syncValue(sourceInput.value, sourceInput);
    }

    document.addEventListener('input', handleInput, true);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fall-campaign-guide"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function hideLoader(formArea) {
      var loader = formArea.querySelector('.js-fall-guide-form-loader');
      if (!loader) return;
      loader.setAttribute('hidden', 'hidden');
    }

    function getEmbedIframe(formArea) {
      return (
        formArea.querySelector('iframe[id^="JotFormIFrame"]') ||
        formArea.querySelector('iframe[src*="jotform.com"]') ||
        formArea.querySelector('iframe')
      );
    }

    function bindIframeLoad(iframe, formArea) {
      if (!iframe || iframe.dataset.fallGuideLoaderBound === 'true') return;
      iframe.dataset.fallGuideLoaderBound = 'true';
      iframe.addEventListener(
        'load',
        function () {
          hideLoader(formArea);
        },
        { once: true }
      );
    }

    function setupLoader(formArea) {
      if (!formArea) return;

      var iframe = getEmbedIframe(formArea);
      if (iframe) {
        bindIframeLoad(iframe, formArea);
        return;
      }

      var observer = new MutationObserver(function () {
        iframe = getEmbedIframe(formArea);
        if (iframe) {
          bindIframeLoad(iframe, formArea);
          addButtonBeforeForms();
          observer.disconnect();
          return;
        }

        if (formArea.querySelector('.jfForm-wrapper, .jotform-form, .form-all')) {
          hideLoader(formArea);
          addButtonBeforeForms();
          observer.disconnect();
        }
      });

      observer.observe(formArea, { childList: true, subtree: true });
    }

    function addButtonBeforeForms() {
      document.querySelectorAll('.ctct-form-custom').forEach(function (form) {
        // Prevent duplicate buttons
        if (
          form.previousElementSibling &&
          form.previousElementSibling.classList.contains('custom-form-button')
        ) {
          return;
        }

        var button = document.createElement('a');

        button.href = 'https://cdn.shopify.com/s/files/1/0610/8754/7543/files/CC_Fall_Garden_Guide_FINAL.pdf?v=1787938373';
        button.className = 'custom-form-button';
        button.textContent = 'Download Your Free Guide';
        button.target = '_blank';

        form.before(button);
      });
    }

    function init() {
      document.querySelectorAll('.js-fall-guide-form').forEach(setupLoader);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = this.closest('.section-header');
      const stickyType = (this.getAttribute('data-sticky-type') || '').trim();
      this.stickyType = stickyType;
      this.headerIsAlwaysSticky = stickyType === 'always' || stickyType === 'reduce-logo-size';
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.header && this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
    }

    setHeaderHeight() {
      if (this.header) {
        document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
      }
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    onScroll() {
      if (!this.header) return;
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (this.header.classList.contains('menu-open')) return;

      const headerHeight = this.header.offsetHeight;
      const scrollThreshold =
        headerHeight > 0
          ? headerHeight
          : parseFloat(
              getComputedStyle(document.documentElement).getPropertyValue('--header-height')
            ) || 100;

      // For \"always\" and \"reduce-logo-size\" modes, never hide the header.
      // In \"reduce-logo-size\" we still toggle the scrolled-past-header class for logo shrinking.
      if (this.headerIsAlwaysSticky) {
        const pastThreshold = scrollTop > scrollThreshold;
        const atTop = scrollTop <= 0;

        if (this.stickyType === 'reduce-logo-size') {
          if (pastThreshold) {
            this.header.classList.add('scrolled-past-header');
          } else if (atTop) {
            this.header.classList.remove('scrolled-past-header');
          }
        }

        this.currentScrollTop = scrollTop;
        return;
      }

      const goingDown = scrollTop > this.currentScrollTop;
      const pastThreshold = scrollTop > scrollThreshold;
      const atTop = scrollTop <= 0;
      const preventHide = !!(this.header && this.header.preventHide);

      if (goingDown && pastThreshold && !preventHide) {
        // scrolling down past header -> hide
        this.header.classList.add(
          'scrolled-past-header',
          'shopify-section-header-hidden',
          'shopify-section-header-sticky'
        );
        this.closeMenuDisclosure();
        this.closeSearchModal();
      } else if (!goingDown && pastThreshold) {
        // scrolling up while already past header -> reveal
        this.header.classList.add('scrolled-past-header', 'shopify-section-header-sticky', 'animate');
        this.header.classList.remove('shopify-section-header-hidden');
      } else if (atTop) {
        // back near top -> reset
        this.header.classList.remove(
          'scrolled-past-header',
          'shopify-section-header-hidden',
          'shopify-section-header-sticky',
          'animate'
        );
      }

      this.currentScrollTop = scrollTop;
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["landscape-guide-signup"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function hideLoader(formArea) {
      var loader = formArea.querySelector('.js-landscape-guide-jotform-loader');
      if (!loader) return;
      loader.setAttribute('hidden', 'hidden');
    }

    function getEmbedIframe(formArea) {
      return (
        formArea.querySelector('iframe[id^="JotFormIFrame"]') ||
        formArea.querySelector('iframe[src*="jotform.com"]') ||
        formArea.querySelector('iframe')
      );
    }

    function bindIframeLoad(iframe, formArea) {
      if (!iframe || iframe.dataset.lgJotformLoaderBound === 'true') return;
      iframe.dataset.lgJotformLoaderBound = 'true';
      iframe.addEventListener(
        'load',
        function () {
          hideLoader(formArea);
        },
        { once: true }
      );
    }

    function setupLoader(formArea) {
      if (!formArea) return;

      var iframe = getEmbedIframe(formArea);
      if (iframe) {
        bindIframeLoad(iframe, formArea);
        return;
      }

      var observer = new MutationObserver(function () {
        iframe = getEmbedIframe(formArea);
        if (iframe) {
          bindIframeLoad(iframe, formArea);
          observer.disconnect();
          return;
        }

        if (formArea.querySelector('.jfForm-wrapper, .jotform-form, .form-all')) {
          hideLoader(formArea);
          observer.disconnect();
        }
      });

      observer.observe(formArea, { childList: true, subtree: true });
    }

    function init() {
      document.querySelectorAll('.js-landscape-guide-jotform').forEach(setupLoader);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
